<template>
  <div
    :class="customClases"
    class="select-none px-1 absolute z-10 left-1/2 transform -translate-x-1/2 transition-all duration-600 h-10 bg-secondary-800 text-white rounded-lg flex items-center text-sm">
    <slot name="commons" />
    <div class="hidden md:block">
      <slot name="desktop" />
    </div>
    <div
      ref="moreSection"
      v-outside:click="{ exclude: ['moreSection'], handler: closeMore }"
      class="relative">
      <base-button v-if="baseDropDownVisible"
        @click="toggleMore"
        size="xs" mode="tools">
        <!-- <base-icon name="more"/> -->
        <span class="count font-bold whitespace-nowrap w-18 text-center"> {{ selected }} {{ $t('app.selected_abr') }}</span>
        <base-icon
          :class="{'transform rotate-180':more}"
          class="transition-transform duration-300 ml-2"
          name="chevronup"/>
      </base-button>
      <div v-else class="count font-bold whitespace-nowrap w-full text-center"> {{ selected }} {{ $t('app.selected_abr') }}</div>
    </div>
    <base-drop-down 
      v-if="baseDropDownVisible" 
      autoClose 
      :isOpen="more" 
      position="bottom-right" 
      :customClass="customMoreClases" 
      @toggle="closeMore" >
      <slot name="more" />
    </base-drop-down>
  </div>
</template>

<script>
export default {
  name: 'base-table-select-actions',
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number],
      default: 0
    },
    total: {
      type: [String, Number],
      default: 0
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md',
    }
  },
  data: function () {
    return {
      more: false,
      core: false
    }
  },
  watch: {
    selected: function () {
      if (this.selected === 0) this.more = false
    }
  },
  computed: {
    allSelected: function () {
      return this.selected === this.total
    },
    sizeClasses: function () {
      return {
        'min-w-custom-80': this.size === 'md',
        'min-w-96': this.size === 'lg',
        'min-w-48': this.size !== 'md' && this.size !== 'lg'
      }
    },
    customClases () {
      return {
        'hide-options': !this.baseDropDownVisible,
        'bottom-18 md:bottom-16 lg:bottom-17': this.visibility,
        '-bottom-0': !this.visibility,
        ...this.sizeClasses
      }
    },
    customMoreClases () {
      const size = Object.keys(this.sizeClasses).filter(key => !!this.sizeClasses[key]).join(' ')
      return `w-full ${size} p-1 bg-secondary-800 bottom-10`
    }
  },
  methods: {
    toggleMore: function () {
      this.more = !this.more
    },
    toggleCore: function () {
      this.core = !this.core
    },
    closeMore: function () {
      this.more = false
    },
    closeCore: function () {
      this.core = false
    }
  }
}
</script>

<style lang="scss" scoped>
.min-w-custom-80 {
  min-width: 18rem;
}
.hide-options.min-w-custom-80 {
  min-width: 15.4rem;
}
.hide-options.min-w-48 {
  min-width: 10.27rem;
}
.hide-options.min-w-96 {
  min-width: 20.53rem;
}
</style>
